export const isSafari = () => {
  /* istanbul ignore next */
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;
  return /^((?!chrome|android|CriOS).)*safari/i.test(userAgent);
};
